<template>
  <div class="ActorProfile">
    <template v-if="profile">
      <block-title
        title="Profile"
        :can-edit="hasManagerRights"
        :modal-to-edit="Modal.ACTOR_PROFILE"
      />
      <span
        v-if="profile.date"
        class="Date"
        :title="profile.date | formattedDate"
      >
        Last updated: {{ profile.date | dateFromNow }}
      </span>
      <ul class="ActorProfile-records">
        <li v-for="data in profileData" :key="data.id" class="Record">
          <template v-if="data.value">
            <h3 class="mt-5 mb-1 mr-5 text-xs text-gray-500">
              {{ data.label }}
            </h3>
            <div class="CommentContent" v-html="data.value"></div>
          </template>
        </li>
      </ul>
    </template>

    <template v-if="showWarning">
      <block-title title="Profile" />
      <div class="Warning">
        <p class="Warning-title">This actor does not have a profile.</p>
        <p>
          Profiling the actor provides information for users to know how the
          actor behaves and quickly spot actions that create opportunities for
          us.
        </p>
        <lm-button mini class="mt-3" @click="openProfileModal"
          >Add profile</lm-button
        >
      </div>
    </template>
  </div>
</template>

<script>
import LmButton from '@/components/ui/LmButton'
import {Modal} from '@/lib/definitions'
import {mapGetters} from 'vuex'
import BlockTitle from './BlockTitle'

export default {
  name: 'ActorProfile',
  components: {LmButton, BlockTitle},
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      Modal
    }
  },
  computed: {
    ...mapGetters(['hasManagerRights']),
    showWarning() {
      return !this.profile && this.hasManagerRights
    },
    profileData() {
      return [
        {id: 0, label: 'Description', value: this.profile.description},
        {
          id: 1,
          label: 'Motivation & Objectives',
          value: this.profile.motivation
        },
        {
          id: 2,
          label: 'Strategic resources',
          value: this.profile.strategicResources
        },
        {
          id: 3,
          label: 'Potential actions',
          value: this.profile.potentialActions
        },
        {
          id: 4,
          label: 'Profiling indicators',
          value: this.profile.profilingIndicators
        },
        {
          id: 5,
          label: 'Information sources',
          value: this.profile.informationSources
        }
      ]
    }
  },
  methods: {
    openProfileModal() {
      this.$router.push({query: {modal: Modal.ACTOR_PROFILE}})
    }
  }
}
</script>

<style scoped>
.ActorProfile {
  .Warning {
    margin-top: 20px;
    padding: 12px;
    border: 1px solid theme('colors.gray.300');
    color: theme('colors.gray.700');
    &-title {
      @apply font-medium text-gray-900;
    }
    p {
      margin: 0;
    }
  }
  .Date {
    display: block;
    margin-top: -12px;
    font-size: 12px;
    color: #969696;
    cursor: pointer;
  }
  &-records {
    margin: 0;
    padding: 0;
    .Record {
      .Content {
        flex-grow: 1;
        p {
          margin: 0;
          & + ul {
            margin-top: 5px;
          }
        }
        ul {
          margin: 0;
          padding: 0 0 0 18px;
          li {
            list-style: disc;
            margin-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>
